import type * as React from 'react';

function SvgArrowForward(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" height="1em" viewBox="0 0 24 24" width="1em" {...props}>
      <path
        d="M17.207 11.293L8.207 2.293C7.8164 1.9024 7.1836 1.9024 6.7929 2.293C6.4022 2.6836 6.4023 3.3164 6.7929 3.7071L15.0859 12.0001L6.7929 20.2931C6.4023 20.6837 6.4023 21.3165 6.7929 21.7072C6.9882 21.9025 7.2441 22.0002 7.4999 22.0002C7.7557 22.0002 8.0116 21.9025 8.2069 21.7072L17.2069 12.7072C17.5975 12.3166 17.5976 11.6837 17.207 11.293Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgArrowForward;
